module.exports = "<div class=\"{{baCheckboxClass}}\">\n\t<label class=\"checkbox-inline custom-checkbox nowrap\">\n\t\t<input type=\"checkbox\" [checked]=value\n\t\t       (change)=\"onChange($event.target.checked)\"\n\t\t       [disabled]=\"disabled\" [value]=\"value\">\n\t\t<span>{{label}}</span>\n\t</label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baCheckbox/baCheckbox.html
// module id = ../../../../../src/app/theme/components/baCheckbox/baCheckbox.html
// module chunks = main